import request from "@/utils/request";

// 查询学科列表
export const  listSubject =(query) =>{
    return request({
        url: "/businessservice/jyeoo/base/gainSubject",
        method:"get",
        params: query
    })
}

// 查询教材版本列表
export const  listEdition =(query) =>{
    return request({
        url: "/businessservice/jyeoo/base/gainEdition",
        method:"get",
        params: query
    })
}

// 查询教材版本年级列表
export const  listGrade =(data) =>{
    return request({
        url: "/businessservice/jyeoo/base/gainGrade",
        method:"post",
        data: data
    })
}

// 查询教材列表
export const  listBook =(data) =>{
    return request({
        url: "/businessservice/jyeoo/base/gainBookList",
        method:"post",
        data: data
    })
}

// 查询教材章节列表
export const  listCategory =(query) =>{
    return request({
        url: "/businessservice/jyeoo/base/gainBookCategory",
        method:"get",
        params: query
    })
}

// 查询教材章节列表
export const  listQuesType =(query) =>{
    return request({
        url: "/businessservice/jyeoo/base/gainQueType",
        method:"get",
        params: query
    })
}

// 查询试题来源列表
export const  listQuesSource =(query) =>{
    return request({
        url: "/businessservice/jyeoo/base/gainQueSource",
        method:"get",
        params: query
    })
}

// 查询试题能力列表
export const  listQuesAbility =(query) =>{
    return request({
        url: "/businessservice/jyeoo/base/gainAbility",
        method:"get",
        params: query
    })
}

// 查询试题列表
export const  listQuestion =(data) =>{
    return request({
        url: "/businessservice/jyeoo/ques/gainQuesCondition",
        method:"post",
        data: data
    })
}

// 查询考点（知识点）列表
export const  listPoint =(query) =>{
    return request({
        url: "/businessservice/jyeoo/base/gainPoint",
        method:"get",
        params: query
    })
}